import SimplePopModal from './simple-pop-modal.vue'

SimplePopModal.install = function (Vue) {
  Vue.component(SimplePopModal.name, SimplePopModal)
}
export default SimplePopModal
